/**
 * Assets de marque (dossier public/).
 */
export const APP_LOGO_SRC = '/logo.png';
